import React, { PureComponent } from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';
import Image from '../atoms/Image/Image';

import { Align } from '@shared/enums/align';
import { breakpoint } from 'theme';

const Container = styled(Box)`
  border-bottom: 1px solid ${props => props.theme.colors.darkMercury};
`;

const Logo = styled(Image)`
  width: calc(100% - 10em);
  min-width: 14.375em;
  max-width: 23em;

  ${breakpoint.m`
    width: calc(100% - 60em);
    min-width: 23em;
    max-width: 27.5em;
  `}

  ${breakpoint.lg`
    width: 100%;
    max-width: 27.5em;
  `}
`;

type ResellerBannerProps = {
  image: string;
};

class ResellerBanner extends PureComponent<ResellerBannerProps> {
  render() {
    const { image } = this.props;

    return (
      <Container
        backgroundColor="white"
        align={Align.Center}
        pt={4.25}
        pb={4.25}
        pl={1.25}
        pr={1.25}
        mPt={3.75}
        mPb={3.75}
        lgPt={4.75}
        lgPb={4.75}
      >
        <Logo src={image} />
      </Container>
    );
  }
}

export default ResellerBanner;
